import moment from "moment";

export const TIPOS_CAMPO = [
  { value: "texto", label: "Texto" },
  { value: "numero", label: "Número" },
  { value: "fecha", label: "Fecha" },
  { value: "booleano", label: "Sí / No" },
  { value: "seleccion", label: "Selección (opciones propias)" },
  { value: "referencia", label: "Referencia a catálogo" },
];

export const ENTIDADES_REFERENCIA = [
  { value: "cliente", label: "Cliente" },
  { value: "proyecto", label: "Proyecto" },
  { value: "subProyecto", label: "Sub proyecto" },
  { value: "insumo", label: "Insumo" },
  { value: "empleado", label: "Empleado" },
  { value: "usuario", label: "Usuario" },
  { value: "pedido", label: "Pedido" },
  { value: "canalVenta", label: "Canal de venta" },
];

export const etiquetaDe = (catalogo, value) => catalogo.find((c) => c.value === value)?.label || value;

export const slugifyCampoKey = (etiqueta, keysExistentes = []) => {
  const base = (etiqueta || "campo")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+(.)/g, (_, chr) => chr.toUpperCase())
    .replace(/[^a-zA-Z0-9]/g, "") || "campo";

  if (!keysExistentes.includes(base)) return base;

  let sufijo = 2;
  while (keysExistentes.includes(`${base}${sufijo}`)) sufijo += 1;
  return `${base}${sufijo}`;
};

export const flattenCampos = (secciones = []) =>
  secciones.flatMap((seccion) =>
    (seccion.campos || [])
      .filter((campo) => campo.estado !== 2)
      .map((campo) => ({ ...campo, seccionNombre: seccion.nombre }))
  );

export const valoresParaFormulario = (secciones, valores = {}) => {
  const campos = flattenCampos(secciones);
  const resultado = { ...valores };

  campos.forEach((campo) => {
    if (campo.tipo === "fecha" && resultado[campo.key] != null && resultado[campo.key] !== "") {
      const fecha = moment(resultado[campo.key]);
      resultado[campo.key] = fecha.isValid() ? fecha : null;
    }
  });

  return resultado;
};

export const formatearValorCampoOrden = (campo, valor) => {
  if (campo.tipo === "booleano") return valor ? "Sí" : "No";
  if (campo.tipo === "fecha") {
    const fecha = new Date(valor);
    return Number.isNaN(fecha.getTime()) ? String(valor) : fecha.toLocaleDateString("es-MX");
  }
  if (campo.tipo === "seleccion") {
    return (campo.opciones || []).find((o) => o.valor === valor)?.etiqueta || String(valor);
  }
  return String(valor);
};
